import { createSelector } from 'reselect';

export const selectPhotoSessions = (state) => state.photoSessions;
export const selectPhotoSessionDetail = (state) => state.photoSessionDetail;

export const selectNotStartedPhotoSessions = (photoSessions) => photoSessions && photoSessions.notStarted;

export const selectToReschedulePhotoSessions = (photoSessions) =>
  photoSessions && photoSessions.toReschedule;

export const selectHasToReschedulePhotoSessions = (photoSessions) =>
  Boolean(photoSessions && photoSessions.toReschedule && photoSessions.toReschedule.length);

export const selectStartedPhotoSessions = (photoSessions) => photoSessions && photoSessions.started;

export const selectShowDetailError = (photoSessionDetail) => photoSessionDetail && photoSessionDetail.showError;

export const selectShowNotStartedListError = (photoSessions) => photoSessions && photoSessions.showNotStartedListError;

export const selectShowStartedListError = (photoSessions) => photoSessions && photoSessions.showStartedListError;

export const selecthasFetchedNotStartedPhotoSessions = (photoSessions) =>
  photoSessions && photoSessions.hasFetchedNotStartedPhotoSessions;

export const selecthasFetchedStartedphotoSessions = (photoSessions) =>
  photoSessions && photoSessions.hasFetchedStartedPhotoSessions;

export const makeSelectNotStartedPhotoSessions = () => createSelector(
  selectPhotoSessions,
  selectNotStartedPhotoSessions,
);

export const makeSelectToReschedulePhotoSessions = () => createSelector(
  selectPhotoSessions,
  selectToReschedulePhotoSessions,
);

export const makeSelectHasToReschedulePhotoSessions = () => createSelector(
  selectPhotoSessions,
  selectHasToReschedulePhotoSessions,
);

export const makeSelectHasFetchedNotStartedPhotoSessions = () => createSelector(
  selectPhotoSessions,
  selecthasFetchedNotStartedPhotoSessions,
);

export const makeSelectHasFetchedStartedPhotoSessions = () => createSelector(
  selectPhotoSessions,
  selecthasFetchedStartedphotoSessions,
);

export const makeSelectStartedPhotoSessions = () => createSelector(
  selectPhotoSessions,
  selectStartedPhotoSessions,
);

export const makeSelectShowDetailError = () => createSelector(
  selectPhotoSessionDetail,
  selectShowDetailError,
);

export const makeSelectShowNotStartedListError = () => createSelector(
  selectPhotoSessions,
  selectShowNotStartedListError,
);

export const makeSelectShowStartedListError = () => createSelector(
  selectPhotoSessions,
  selectShowStartedListError,
);
